export default __webpack_public_path__ + "static/media/GT-America-Standard-Bold.8a66dddc.woff2";